import { ADMIN_GROUP_METAS } from './index';
import { Action } from '../action';

export class AdminGroupMetasInitAction implements Action {
	readonly type = ADMIN_GROUP_METAS.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasDestroyAction implements Action {
	readonly type = ADMIN_GROUP_METAS.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsServicesAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_SERVICES;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsCcAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_CC;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsDasAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_DAS;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsPpaAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_PPA;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsInternetAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_INTERNET;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsServicesSuccessAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_SERVICES_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsCcSuccessAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_CC_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsDasSuccessAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_DAS_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsPpaSuccessAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_PPA_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsInternetSuccessAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_INTERNET_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsServicesFailureAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_SERVICES_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsCcFailureAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_CC_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsDasFailureAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_DAS_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsPpaFailureAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_PPA_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminGroupMetasUpdateConditionsInternetFailureAction implements Action {
	readonly type = ADMIN_GROUP_METAS.UPDATE_CONDITIONS_INTERNET_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
